import { useState } from "react";
import { GateAddModalHeader } from "./GateAddModalHeader";
import { GateAddModalFormWrapper } from "./GateAddModalFormWrapper";

const GateAddModal = ({
  listing,
  device,
  setDevice,
  setOpenGateAddModal,
  getGateLists
}) => {
  const [changeStatus, setChangeStatus] = useState(false)
  return (
    <>
      <div
        className="modal fade show d-block"
        id="kt_modal_add_user"
        role="dialog"
        tabIndex={-1}
        aria-modal="true"
      >
        {/* begin::Modal dialog */}
        <div className="modal-dialog modal-dialog-centered mw-600px">
          {/* begin::Modal content */}
          <div className="modal-content">
            <GateAddModalHeader
              listing={listing}
               device={device}
               setDevice={setDevice}
               setOpenGateAddModal={setOpenGateAddModal}
               changeStatus={changeStatus}
               setChangeStatus={setChangeStatus}
            />
            {/* begin::Modal body */}
            <div className="modal-body scroll-y mx-5 mx-xl-5 my-2 p-4">
              <GateAddModalFormWrapper
              listing={listing}
               device={device}
               setDevice={setDevice}
               setOpenGateAddModal={setOpenGateAddModal}
               getGateLists={getGateLists}
               changeStatus={changeStatus}
               setChangeStatus={setChangeStatus}
              />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className="modal-backdrop fade show"></div>
      {/* end::Modal Backdrop */}
    </>
  );
};

export { GateAddModal };
